import * as React from 'react';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';

interface AddPriceListTierPopupProps {
    tierName: string;
    tierDiscount: TierDiscount[];
    customerId: number;
    customerOptions: GenericList[];
    systemCompanyId: number;
    showModal: boolean;
    hideModal(): void;
    updateTier(tierName: string): void;
    updateTierDiscount(tierDiscount: TierDiscount[]): void;
    updateCustomer(customerId: number): void;
    saveModal(typeId: number): void;
}

interface AddPriceListTierPopup {
    typeId: number;
    errors: any;
}

interface GenericList {
    id: number;
    name: string;
}

interface TierDiscount {
    name: string;
    startDays: number;
    endDays: number;
    discountPercent: number;
}

export default class AddPriceListTier extends React.Component<AddPriceListTierPopupProps, AddPriceListTierPopup> {
    constructor(props: any) {
        super(props);

        this.state = {
            typeId: 1,
            errors: {}
        };

    }

    onTypeChanged = (e: any) => {
        let change: any = {};
        change[e.target.name] = e.target.value * 1;
        this.setState(change);
    }

    hideModal = () => {
        this.props.hideModal();
    }

    onTierNameChanged = (e: any) => {
        let tierName = e.target.value;
        this.props.updateTier(tierName);
    }

    onCustomerChanged = (e: any) => {
        let customerId = e.target.value;
        this.props.updateCustomer(customerId);
    }

    onCellChange = (e: any, index: number) => {
        var tierDiscount = this.props.tierDiscount;
        var tierDiscountItem = tierDiscount[index];

        let newtierDiscountItem: any = {};
        newtierDiscountItem = tierDiscountItem;
        newtierDiscountItem[e.target.name] = e.target.value;

        //if last row we need to add a new blank row
        let lastRow = tierDiscount.length - 1;
        if (index === lastRow) {
            var blankRow = this.addBlankRow();
            tierDiscount.push(blankRow);
        }

        this.props.updateTierDiscount(tierDiscount);
    }

    addBlankRow = () => {
        var blankRow: TierDiscount = {
            name: "",
            startDays: 0,
            endDays: 0,
            discountPercent: 0
        };
        return blankRow;
    }

    deleteItem = (e: any, index: number) => {
        e.preventDefault();
        var tierDiscount = this.props.tierDiscount;
        tierDiscount.splice(index, 1);
        this.props.updateTierDiscount(tierDiscount);
    }

    validate = () => {
        let errors: any = {};
        let formIsValid = true;

        if (this.state.typeId === 1 && !this.props.tierName) {
            errors["tierName"] = "Tier Name is required!";
            this.setState({ errors: errors });
            return false;
        }

        if (this.state.typeId === 2 && this.props.customerId <= 0) {
            errors["customerId"] = "Customer is required!";
            this.setState({ errors: errors });
            return false;
        }

        var discounts = this.props.tierDiscount;
        if (discounts.length > 0) {
            var errorString = "Please enter the following values: ";
            var error = false;
            //last row is a blank new row so ignore
            for (var i = 0; i < discounts.length - 1; i++) {
                var newErrorString = "";
                if (!discounts[i].name) {
                    newErrorString += " Name, ";
                    error = true;
                }
                var dayError = false;
                if (!discounts[i].startDays || discounts[i].startDays <= 0) {
                    newErrorString += " Start Day, ";
                    error = true;
                    dayError = true;
                }
                if (!discounts[i].endDays || discounts[i].endDays <= 0) {
                    newErrorString += " End Day, ";
                    error = true;
                    dayError = true;
                }
                if (!dayError && discounts[i].endDays <= discounts[i].startDays) {
                    newErrorString += " End Day > Start Day, ";
                    error = true;
                }
                if (!discounts[i].discountPercent || discounts[i].discountPercent <= 0) {
                    newErrorString += " Discount Percent, ";
                    error = true;
                }
                if (newErrorString != "") {
                    errorString += "\n"
                    errorString += "Row " + (i + 1) + ": " + newErrorString;
                    errorString = errorString.substring(0, errorString.length - 2);
                }
            }
            if (error) {
                formIsValid = false;
                errors["discounts"] = errorString;
            }
        }

        this.setState({ errors: errors });
        return formIsValid;
    }

    saveModal = () => {
        if (this.validate()) {
            this.props.saveModal(this.state.typeId);
        } else {
            toast.error("Please fix validations errors before Saving");
        }
        
    }

    render() {
        let contents = this.renderDetails();

        return <div>
            {contents}
        </div>;
    }

    renderDetails = () => {
        let customerOptions = this.props.customerOptions;
        let tierDiscount = this.props.tierDiscount;
        let lastRow = tierDiscount.length - 1;

        return (
            <Modal show={this.props.showModal} onHide={this.hideModal}>
                <Modal.Header className="modal__header--colour">
                    <Modal.Title>Add New PriceList Tier</Modal.Title>
                    <button type="button" className="close" onClick={this.hideModal}>&times;</button>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <div className="input-group">
                            <label htmlFor="typeId" className="pricelist-add-type--width">Price List Type</label>
                            <input type="radio" className="marginRight10" id="tier" name="typeId" value={1} checked={this.state.typeId === 1} onChange={(e) => this.onTypeChanged(e)}></input>
                            <label className="label" htmlFor="tier">Tier</label>
                            <input type="radio" className="marginRight10" id="custom" name="typeId" value={2} checked={this.state.typeId === 2} onChange={(e) => this.onTypeChanged(e)}></input>
                            <label className="label" htmlFor="custom">Custom</label>
                        </div>

                        <div className={this.state.typeId === 1 ? "" : "hidden"}>
                            <label className="input-group" htmlFor="tierName">
                                <span className="label">Tier Name</span>
                                <input className="input" type="text" maxLength={30} id="tierName" name="tierName" value={this.props.tierName} onChange={(e) => this.onTierNameChanged(e)}></input>
                            </label>
                            <span className="label errors">{this.state.errors["tierName"]}</span>
                        </div>
                        <div className={this.state.typeId === 1 ? "hidden" : ""}>
                            <label className="input-group" htmlFor="customer">
                                <span className="label">Customer </span>
                                <select id="customerId" name="customerId" value={this.props.customerId} onChange={(e) => this.onCustomerChanged(e)}>
                                    <option hidden defaultValue="-1"></option>
                                    {customerOptions.map(cust =>
                                        <option key={cust.id} value={cust.id}>{cust.name}</option>
                                    )};
                                </select>
                            </label>
                            <span className="label errors">{this.state.errors["customerId"]}</span>
                        </div>

                        <div className={this.props.systemCompanyId === 2 ? "overflowAuto" : "hidden"}>
                            <table className="table table__small tableColours">
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Start Day</th>
                                        <th>End Day</th>
                                        <th>Discount %</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                {tierDiscount.map((item, index) =>
                                    <tbody key={index}>
                                        <tr>
                                            <td className="table__text--align">
                                                <input type='text' maxLength={30} id="name" name="name" className="form-control" value={item.name} onChange={(e) => this.onCellChange(e, index)} />
                                            </td>
                                            <td className="table__text--align">
                                                <input type='number' min="0" step="1" className='form-control textalignright pricelist-input-sm' id="startDays" name="startDays" value={item.startDays} onChange={(e) => this.onCellChange(e, index)} />
                                            </td>
                                            <td className="table__text--align">
                                                <input type='number' min="0" step="1" className='form-control textalignright pricelist-input-sm' id="endDays" name="endDays" value={item.endDays} onChange={(e) => this.onCellChange(e, index)} />
                                            </td>
                                            <td className="table__text--align">
                                                <input type='number' min="0" step="1" className='form-control textalignright pricelist-input-sm' id="discountPercent" name="discountPercent" value={item.discountPercent} onChange={(e) => this.onCellChange(e, index)} />
                                            </td>
                                            <td className="table__text--align">
                                                <div className={index === lastRow ? "hidden" : "delete--tablecell"}>
                                                    <a className="makeitred" href="#" onClick={(e) => this.deleteItem(e, index)}>
                                                        <span className="fas fa-times-circle edit--icon alignIconCenter"></span>
                                                    </a>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                )}
                            </table>
                            {this.state.errors["discounts"] ?
                                (this.state.errors["discounts"]).split("\n").map((item: any, key: any) => {
                                    return <span className="label errors" key={key}>{item}<br /></span>
                                })
                                : ""}
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="popup-button--yes" onClick={this.saveModal}>Save</button>
                </Modal.Footer>
            </Modal>

        )
    }

}